module.exports = __webpack_public_path__ + "img/a.dc185809.jpg";